import { filter, remplazarPorTildeASinTilde } from "../../helpers/Buscador";
import { types } from "../../types/types";

const initialState = {
    items: [],
    itemsResults: [],
    itemsPracticas: [],
    itemsPracticasAux: [],
    loading: false
  };
  
  export const abmPrestadoresRestringidos = (state = initialState, action) => {
    switch (action.type) {
      case types.abmPrestadoresRestringidosTraerStart:
        return {
          ...state,
          loading: true,
          items: []
        };
      case types.abmPrestadoresRestringidosTraerSuccess:
        return {
          ...state,
          loading: false,
          items: action.payload,
          itemsAux: action.payload
        };
      case types.abmBuscarPrestadoresRestringidos:
          var itemsResults = state.itemsAux.filter(n => filter(remplazarPorTildeASinTilde(n.razonSocial), remplazarPorTildeASinTilde(action.payload)))
          return {
              ...state,
              items: itemsResults
          };
      case types.prestadoresRestringidosTraerError:
        return {
          ...state,
          loading: false,
        };
      //PRACTICAS
      case types.abmPracticasPrestadoresRestringidosSuccess:
                return {
                    ...state,
                    loading: false,
                    itemsPracticas: action.payload,
                    itemsPracticasAux: action.payload
                };
        case types.abmBuscarPracticasRestringidosSuccess:
                var itemsResultsP = state.itemsPracticasAux.filter(n => filter(remplazarPorTildeASinTilde(n.descripcionNomenclador), remplazarPorTildeASinTilde(action.payload)))
                return {
                    ...state,
                    itemsPracticas: itemsResultsP
                };
      default:
        return state;
    }
  };
  